import { render } from "./ListAssets.vue?vue&type=template&id=3a8d2ff7&scoped=true"
import script from "./ListAssets.vue?vue&type=script&lang=js"
export * from "./ListAssets.vue?vue&type=script&lang=js"

import "./ListAssets.vue?vue&type=style&index=0&id=3a8d2ff7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8d2ff7"]])

export default __exports__